// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-module--root--2bivt","text":"banner-module--text--297Cd"};